<template>


	<v-bottom-navigation class="w-100 background-tile-secondary bottom-nav">
		<div class="bottom-nav__container w-100 h-100">


			<router-link to="/earn">
				<div class="bottom-nav__item py-1 px-6 px-sm-10 rounded text-white"
					:class="{ 'button--primary': currentPath === '/earn' }">
					<v-icon>
						<earn-icon></earn-icon>
					</v-icon>
					<span>Earn</span>
				</div>
			</router-link>


			<router-link to="/rewards">
				<div class="bottom-nav__item py-1 px-4 px-sm-10 rounded text-white"
					:class="{ 'button--primary': currentPath === '/rewards' }">
					<v-icon>
						<rewards-icon></rewards-icon>
					</v-icon>
					<span>Rewards</span>
				</div>
			</router-link>

			<router-link to="/offers">
				<div class="bottom-nav__item py-1 px-4 px-sm-10 rounded text-white"
					:class="{ 'button--primary': currentPath === '/offers' }">
					<v-icon>
						<offers-icon></offers-icon>
					</v-icon>
					<span>Offers</span>
				</div>
			</router-link>


			<router-link to="/referrals">
				<div class="bottom-nav__item py-1 px-4 px-sm-10 rounded text-white"
					:class="{ 'button--primary': currentPath === '/referrals' }">
					<v-icon>
						<referrals-icon></referrals-icon>
					</v-icon>
					<span>Referral</span>
				</div>
			</router-link>


		</div>
	</v-bottom-navigation>

</template>



<script setup>

import { computed } from "vue";
import { useRoute } from "vue-router";
import EarnIcon from "@/icons/Earn.vue";
import OffersIcon from "@/icons/Offers.vue";
import RewardsIcon from "@/icons/Rewards.vue";
import ReferralsIcon from "@/icons/Referrals.vue";
const route = useRoute();

const currentPath = computed(() => {
	return route.path;
});

</script>